import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";
import { RESOURCE_QUERY_META } from "@/api/resourceQuery";
import type { IBill } from "@/api/restaurant/purchases";
import type { PaginationParams } from "@/types/api";
import { useAdminCurrency } from "@/utils/hooks/useAdminCurrency";

import { transactionsAdminApi } from "./adminTransactionsApi";
import type { PosSettlementsResponse } from "./types";

export const useGetAllAdminTransactionsQuery = (params?: PaginationParams) => {
  const currency = useAdminCurrency();
  return useQuery({
    queryKey: [QUERY_KEYS.adminTransacions, params, currency],
    queryFn: () => transactionsAdminApi.getAllAdminTransactions(params),
  });
};

export const useGetTransactionsDetailsByIdQuery = (id: string) => {
  return useQuery<IBill>({
    queryKey: [QUERY_KEYS.adminTransactionDetails, id],
    queryFn: () => transactionsAdminApi.getTransactionsDetailsById(id),
    enabled: !!id,
    placeholderData: keepPreviousData,
    meta: RESOURCE_QUERY_META,
  });
};

export const useGetPosSettlementsByIdQuery = (id: string) => {
  return useQuery<PosSettlementsResponse>({
    queryKey: [QUERY_KEYS.adminPosSettlements, id],
    queryFn: () => transactionsAdminApi.getPosSettlementsById(id),
    enabled: !!id,
  });
};
